module.exports = __webpack_public_path__ + "img/tuto_img_internet_06.32dcc72b.png";